import PriorityHighIcon from '@mui/icons-material/PriorityHigh'
import { Box, CircularProgress, Typography } from '@mui/material'

type NoDataMessageProps = {
  hasNoData: boolean
  isFetching: boolean
  isLoading: boolean
}

export const NoDataMessage = ({ hasNoData, isLoading, isFetching }: NoDataMessageProps) => {
  if (isLoading || isFetching) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: hasNoData ? 'column' : 'row',
          alignItems: 'center',
          justifyContent: 'center',
          paddingY: 5,
          width: '100%',
          backgroundColor: ({ palette }) => `${palette.primary.main}0D`
        }}
      >
        <CircularProgress />
      </Box>
    )
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: hasNoData ? 'column' : 'row',
        alignItems: 'center',
        justifyContent: 'center',
        paddingY: 5,
        width: '100%',
        backgroundColor: ({ palette }) => `${palette.primary.main}0D`
      }}
    >
      {hasNoData && (
        <PriorityHighIcon
          sx={{
            fontSize: 48,
            color: ({ palette }) => palette.primary.main,
            mb: 2
          }}
        />
      )}
      <Typography
        sx={{
          textAlign: 'center',
          color: ({ palette }) => palette.primary.main,
          fontWeight: 'bold'
        }}
      >
        {hasNoData
          ? 'No Odds Data available for this tournament.'
          : 'Please select all filters to display data!'}
      </Typography>
    </Box>
  )
}
